import { useCallback } from 'react';
import { Container, Heading } from 'yoso';
import { ChallengeEventErrorFallback } from '~/components/Challenge/Event/Error/ChallengeEventErrorFallback';
import {
  useChallengeLeaderboard,
  useChallengeLeaderboardParams,
} from '~/components/Challenge/Leaderboard/ChallengeLeaderboard.hooks';
import styles from '~/components/Challenge/Leaderboard/ChallengeLeaderboardPage.module.scss';

import classNames from 'classnames';
import { format } from 'date-fns';
import { stringify } from 'qs';
import { useHistory } from 'react-router-dom';
import { ChallengeRewardCta } from '~/components/Challenge/Cta/Reward/ChallengeRewardCta';
import {
  ChallengeEventCelect,
  ChallengeEventCelectProps,
} from '~/components/Challenge/Event/Dropdown/ChallengeEventCelect';
import { ChallengeLeaderboard } from '~/components/Challenge/Leaderboard/ChallengeLeaderboard';
import { ChallengeLeaderboardTabs } from '~/components/Challenge/Leaderboard/Nav/ChallengeLeaderboardTabs';
import { ChallengeVersus } from '~/components/Challenge/Versus/ChallengeVersus';
import { QueryErrorBoundary } from '~/components/Error';
import { Page } from '~/components/Page';
//TODO: v4.16.0 Enhance error boundary after discussion
export const ChallengeLeaderboardPage = () => {
  const history = useHistory();
  const params = useChallengeLeaderboardParams();
  const {
    data: { myScore, week, weekStartAt, weekEndAt, weekStatus },
    isPlaceholderData,
  } = useChallengeLeaderboard({ group: params.group, week: params.eventId });

  const handleCelectChange: ChallengeEventCelectProps['onChange'] = useCallback(
    (value) => {
      history.replace({ search: stringify({ eventId: value }, { addQueryPrefix: true }) });
    },
    [history]
  );
  const scored = !!myScore;
  const safeGroup = scored ? params.group : 'TOP';
  const id = params.eventId || week;

  return (
    <Page
      className={classNames(
        styles.root,
        {
          [styles.scored]: scored,
          [styles.loading]: isPlaceholderData,
        },
        styles[weekStatus]
      )}
      data-event-page_name="challenge_ranking"
      data-event-category="ranking">
      <Container margin="auto">
        <Heading level={4} className={styles.heading}>
          <ChallengeEventCelect value={id.toString()} onChange={handleCelectChange} />
          <p className={styles.period}>
            {format(weekStartAt, 'PP p')} ~ {format(weekEndAt, 'PP p')}
          </p>
        </Heading>
        {scored && <ChallengeVersus eventId={id} className={styles.versus} />}
        {!scored && <ChallengeRewardCta className={styles.cta} group={safeGroup} eventId={id} />}
        <ChallengeLeaderboardTabs
          value={safeGroup}
          eventId={id}
          scored={scored}
          className={styles.tabs}
        />
        <QueryErrorBoundary FallbackComponent={ChallengeEventErrorFallback} resetKeys={[id]}>
          <ChallengeLeaderboard className={styles.list} eventId={id} group={safeGroup} />
        </QueryErrorBoundary>
      </Container>
    </Page>
  );
};
